import * as React from "react"
import { Sparkles } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ProFeatureWrapperProps {
  children: React.ReactNode;
  feature: string;
  isPro: boolean;
}

export const ProFeatureWrapper = ({ children, feature, isPro }: ProFeatureWrapperProps) => (
  <TooltipProvider>
    <div className={`relative ${!isPro ? 'opacity-50' : ''}`}>
      {!isPro && (
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="absolute inset-0 z-10 cursor-not-allowed bg-transparent" />
          </TooltipTrigger>
          <TooltipContent>
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-purple-500" />
              <p>Upgrade to Pro to unlock {feature}</p>
            </div>
          </TooltipContent>
        </Tooltip> 
      )}
      {children}
      {!isPro && (
        <p className="text-xs text-muted-foreground mt-1">Available only for Pro funnels</p>
      )}
    </div>
  </TooltipProvider>
);